module.exports = __webpack_public_path__ + "img/0-02-0a-5fa9a54963526b903869f18149b128e40570ec09d8fa185a7e0a7807e90bbe50_5cd698a1.aad1a7b2.jpg";